function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { useAccentColors } from '../../hooks';
import { Body, Heading } from '../../atoms';
import ReactConfigContext from '../../ReactConfigContext';
export default function ThumbnailListEntry(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'default' : _param_variant, image = param.image, title = param.title, action = param.action, accentColor = param.accentColor, description = param.description, className = param.className;
    var _useContext = useContext(ReactConfigContext), _useContext_config = _useContext.config, LinkComponent = _useContext_config.LinkComponent, ImageComponent = _useContext_config.ImageComponent;
    var accentStyle = useAccentColors([
        'thumbnail-list-entry-accent',
        accentColor
    ]);
    return /*#__PURE__*/ React.createElement("article", {
        style: accentStyle,
        className: className
    }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        className: twMerge('grid gap-5 grid-cols-1 md:block', !!image && 'grid-cols-[auto_1fr]', action.className)
    }), !!image && /*#__PURE__*/ React.createElement("div", {
        className: "w-[5rem] h-[5rem] rounded-xl overflow-hidden safari-fix-transform md:w-full md:h-[16rem]"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        className: twMerge('w-full h-full object-cover object-center', image.className)
    }))), /*#__PURE__*/ React.createElement("div", {
        className: twMerge('md:mt-5', variant === 'default' && 'text-thumbnail-list-entry-accent', variant === 'inverted' && 'text-fg-inverted')
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "mt-3 md:mt-5"
    }, description))));
}

//# sourceMappingURL=ThumbnailListEntry.js.map